import type { PropertyKind, PropertySpecs, PropertyType } from '@nexofacil/schemas';
import { formatCents } from './format';

// =============================================================================
// Como um imóvel aparece pro público · um lugar só pra card, página do imóvel
// e landings dedicadas falarem igual.
// =============================================================================

export const propertyTypeLabel: Record<PropertyType, string> = {
  apartment: 'Apartamento',
  house: 'Casa',
  land: 'Terreno',
  commercial: 'Sala comercial',
};

/** Plural pros filtros ("Apartamentos", "Casas"). */
export const propertyTypePlural: Record<PropertyType, string> = {
  apartment: 'Apartamentos',
  house: 'Casas',
  land: 'Terrenos',
  commercial: 'Salas comerciais',
};

const plural = (n: number, one: string, many: string) => `${n} ${n === 1 ? one : many}`;

/** "2 quartos · 1 banheiro · 1 vaga · 48 m²" (só o que foi preenchido). */
export function specsLine(specs: PropertySpecs | null | undefined): string {
  if (!specs) return '';
  const parts: string[] = [];
  if (specs.bedrooms) parts.push(plural(specs.bedrooms, 'quarto', 'quartos'));
  if (specs.bathrooms) parts.push(plural(specs.bathrooms, 'banheiro', 'banheiros'));
  if (specs.parking) parts.push(plural(specs.parking, 'vaga', 'vagas'));
  if (specs.areaSqm) parts.push(`${specs.areaSqm.toLocaleString('pt-BR')} m²`);
  return parts.join(' · ');
}

type Priced = { kind?: PropertyKind; priceRange?: { min: number; max: number } | null };

/** Imóvel avulso tem preço fechado; empreendimento tem "a partir de". */
export function priceLabel(p: Priced, empty = 'Consulte valores e condições'): string {
  if (!p.priceRange) return empty;
  const value = formatCents(p.priceRange.min);
  return p.kind === 'listing' ? value : `A partir de ${value}`;
}
